// Libraries
import React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';

/**********
 ** Component: IconIndividualRunner
 ** @type: functional stateless component
 ** @description:
 **********/
const IconIndividualRunner = () => {
	return (
		<Icon
			d="M29.91,3.32s0,0,0,.06-.05.09,0,.06c-.83.48-1.64.59-1.46,2a7.36,7.36,0,0,0,0,1c.14,0,.09.36,0,.33-.17.38-.06,1-.83,1,0-.22-2.46.64-2.8.85.07.08.17,0,.27,0a.3.3,0,0,1,.26,0A8.47,8.47,0,0,1,23,9.1c-1,.24-2,.57-2.93.85-.76.22-1.81.34-2,1.28,0,.1.09.9.21.93a5.12,5.12,0,0,0,.39-.56c.29-.39.66-.79.87-.39-.07.07-.89.53-.59.68s1.36-1,1.6-1.17a7.31,7.31,0,0,1,3.09-.5c.62-.05,2.47-.8,2.87-.61.87.42-.29.24-.29.54,0,.54.85.32,1.63.09s1.28-.38,1.32-.12a7.56,7.56,0,0,1,0,3.72c-.41,1.21-1.59,2-1.68,3.38,0,.61.31,1.08.2,1.65a8.67,8.67,0,0,1-.81,1.61,24.29,24.29,0,0,1-2.3,4c-1.36,1.77-2.15,3.86-3.57,5.38-.9,1-.76.88.23,1.69.16.13,2.69,2.35,3,1.89.17-.3-1-2-1-2.43a3.13,3.13,0,0,1,.76-2.44c1.56-2.38,3.58-4.38,5.31-6.63.71-.91,1-2.12,2-2.25.42-.06,2.87.36,3.27.86.28.34-1,5.61-1.79,6,0,0-.13,0-.12,0a3.3,3.3,0,0,0-.88,1.62c.17.52,2,1,2.4,1.2.23.1,1.92.94,2.06.42,0-.16-.94-1.05-1.06-1.2-1.43-1.81-.53-3.07.59-5,.47-.8,1.74-2.39,1.56-3.39s-1.58-1.83-2.37-2.35c-.5-.32-2.45-1-2.67-1.51s.54-2.37.71-2.94.39-2.13,1.14-2,1.09,1.71,1.76,2c1.16.42,1.21-.63,1.41-1.67s.51-2.24.67-3.34c.12-.8.25-.78-.14-1.4,0,0-.94-.71-.88-.71-.24,0,.06,1-.09,1.17.07-.1-.26-.86-.4-.65-.56.88.56,2.57.06,3.68s-.52.95-1.17,0a20.12,20.12,0,0,0-1-1.76c-.31-.35-1.34-.62-1.52-.92-.47-.84.83-1.08,1.05-1.54.7-1.53-.9-3.68-2.44-3.68A1.73,1.73,0,0,0,29.91,3.32Z"
			fill="#fff"
			fillRule="evenodd"
			transform="translate(27, 44)"
		/>
	);
};

const Icon = styled.path`
	width: ${rem('56px')};
	height: ${rem('36px')};
`;

export default IconIndividualRunner;



// WEBPACK FOOTER //
// ./src/components/ui/layout/icons/icon-individual-runner.jsx